import { styled } from '@withjoy/joykit';
import { Flex } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

export const StyledContainer = styled(Flex)<{ hasError?: boolean }>`
  padding: ${props => props.theme.space[4]} ${props => props.theme.space[5]};
  border: 1px solid ${props => props.theme.colors.mono5};
  align-items: center;
  width: 100%;
  max-width: ${() => pxToRem(128)};
  overflow: hidden;
  border-radius: ${props => props.theme.radii[3]};
  ${props => props.hasError && `border-color: ${props.theme.colors.red3}`};
  &:focus-within {
    border: 1px solid ${props => props.theme.colors.mono14};
  }
`;

export const Wrapper = styled.div`
  position: relative;
  display: inline-block;
`;

export const StyledInput = styled.input`
  font: inherit;
  padding: 4px;
  border: none;
  min-width: 1ch;
  width: auto;
  outline: none;
  color: ${props => props.theme.colors.mono14};
`;

export const Mirror = styled.span`
  position: absolute;
  visibility: hidden;
  white-space: pre;
  font: inherit;
  padding: 4px;
`;
